import React from 'react'
import { CFView, DefaultScreen, MobileScreen } from 'components'
import { contactbg, mobileContactbg } from 'images'
import RestaurantDetails from './RestaurantDetails'
import Hours from './Hours'
import Map from './Map'
import SocialMedia from './SocialMedia'
import DownloadApp from './DownloadApp'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center bg="rgba(0,0,0,.5)">
          <Map />
          <CFView
            column
            center
            w="100%"
            image={`url(${mobileContactbg}) center / cover no-repeat`}
          >
            <CFView pv="20px" w="100%" column center>
              <RestaurantDetails />
              <Hours />
              <DownloadApp />
              <SocialMedia />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column>
          <Map />
          <CFView
            w="100%"
            pv="50px"
            row
            alignCenter
            justifyAround
            image={`url(${contactbg}) center / cover no-repeat`}
          >
            <CFView w="100%" row justifyAround maxWidth="1050px">
              <DownloadApp />
              <CFView column>
                <RestaurantDetails />
                <SocialMedia />
              </CFView>
              <Hours />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
